import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { BaseAuthComponent } from '../../abstract-components/base-auth.component';
import { DialogService } from '~console/app/~shared/services/dialog.service';

@Component({
  selector: 'company-user-migration-modal',
  standalone: false,
  templateUrl: './company-user-migration-modal.component.html',
  styleUrl: './company-user-migration-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanyUserMigrationModalComponent extends BaseAuthComponent {
  private readonly _dialogService = inject(DialogService);

  currentUser = toSignal(this._authFacade.currentUser$, {
    initialValue: null
  });

  managerName = computed(() => {
    const currentUser = this.currentUser();
    if (!currentUser) return 'votre gestionnaire';
    const manager = currentUser.organization.manager;
    if (!manager) return 'votre gestionnaire';
    const fullName =
      [manager.firstName, manager.lastName].filter(Boolean).join(' ') ||
      manager.fullName ||
      manager.username ||
      manager.email;
    return fullName || 'votre gestionnaire';
  });

  organizationName = computed(() => {
    const currentUser = this.currentUser();
    return currentUser?.organization?.name || 'votre entreprise';
  });

  onLogout(): void {
    this._authFacade.logout();
    this._dialogService.closeAll();
  }
}
